import React, { useEffect, useState } from "react";
import { getContactBannerByUid } from "../Service/contactApi"; // adjust path
import Typewriter from "typewriter-effect";
import Breadcrumb from "components/Breadcrumb";
const UUID = "c426123b-42c5-4fa4-b547-610c058c052b";

const ContactBanner: React.FC = () => {
  const [data, setData] = useState<any>(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await getContactBannerByUid(UUID);
        setData(result);
      } catch (err) {
        console.error("Error fetching contact banner:", err);
      }
    };

    fetchData();
  }, []);

  if (!data) return null;

  return (
    <>
      {/* Page Header Start */}
      <div
        className="page-header"
        style={{
          backgroundImage: data.bgImage
            ? `url('${data.bgImage}')`
            : `url('assets/img/contact-banner.png')`,
        }}
      >
        <div className="container py-5">
            <h2 className="display-3 text-white py-5 mb-3  text-center" data-wow-delay="0.2s" style={{
    animation: 'fadeInMiddle 0.8s ease-in-out both',
  }}>
              {data?.title}
               {/* <Typewriter
              key={data.title}
              onInit={(typewriter: any) => {
                typewriter.typeString(data?.title).start();
              }}
              options={{
                delay: 100,
                cursor: "",
              }}
            /> */}
              </h2>
      </div> 
      </div>

      <Breadcrumb/>
      {/* Page Header End */}
    </>
  );
};

export default ContactBanner;
